<textarea
  #inputElement
  type="text"
  rows="1"
  [style.width]="getInputWidth()"
  [style.min-width.px]="minInputWidth()"
  class="border-default bg-surface focus:border-accent-focus focus:ring-accent-focus duration-fast block resize-none overflow-hidden rounded-md border px-2 py-1 transition-colors focus:ring-2 focus:outline-none"
  [value]="processedValue()"
  (input)="onInput($event)"
  [disabled]="disabled()"></textarea>
